import { render, staticRenderFns } from "./orderDeliveryEditPage.vue?vue&type=template&id=7bbc4272&"
import script from "./orderDeliveryEditPage.vue?vue&type=script&lang=ts&"
export * from "./orderDeliveryEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports